<!--
 * @Description: 工资条隐私协议
 * @Author: fely
 * @Date: 2020-09-05 11:22:23
 * @LastEditTime: 2020-10-31 10:21:09
 * @LastEditors: fely
-->
<template>
  <div class="policy-page">
    <div class="title">亿慧工资条隐私政策</div>
    <div class="pre-text">
      <span>版本发布日期：2020-10-24</span>
      <span>版本生效日期：2020-10-24</span>
      <p>《亿慧工资条隐私政策》将帮助您了解以下信息：</p>
      <p>1、我们如何收集和使用您的个人信息</p>
      <p>2、我们如何使用Cookie和同类技术</p>
      <p>3、我们如何共享、转让、公开披露您的个人信息</p>
      <p>4、我们如何保护您的个人信息</p>
      <p>5、您的权力</p>
      <p>6、我们如何处理未成年人的个人信息</p>
      <p>7、本《亿慧工资条隐私政策》如何更新</p>
      <p>8、如何联系我们</p>
    </div>
    <div class="content">
      <div class="box">
        <div class="sub-title">引言</div>
        <div class="text-box">
          <p>
            亿慧工资条（以下简称“我们”）深知个人信息对您的重要性，因此我们会尽全力保护您的个人信息的安全性。本《亿慧工资条隐私政策》旨在说明亿慧工资条如何获取、存储、保护、使用用户的个人信息。请在使用亿慧工资条产品（或服务）前，仔细阅读并了解本《亿慧工资条隐私政策》的内容。您一旦开始使用亿慧工资条平台的产品（或服务），即表示您认同本《亿慧工资条隐私政策》中所述的内容。
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">目录</div>
        <div class="text-box">
          <p class="bold">
            一、《亿慧工资条隐私政策》的适用范围
          </p>
          <p class="bold">
            二、我们如何收集和使用您的个人信息
          </p>
          <p class="bold">
            三、我们如何使用Cookie和同类技术
          </p>
          <p class="bold">
            四、我们如何共享、转让、公开披露您的个人信息
          </p>
          <p class="bold">
            五、我们如何保存和保护您的个人信息
          </p>
          <p class="bold">
            六、您管理个人信息的权力
          </p>
          <p class="bold">
            七、我们如何处理未成年人的个人信息
          </p>
          <p class="bold">
            八、本《亿慧工资条隐私政策》的更新和通知
          </p>
          <p class="bold">
            九、如何联系我们
          </p>
          <p class="bold">
            十、争议解决
          </p>
          <p class="bold">
            附录：定义
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">
          一、《亿慧工资条隐私政策》的适用范围
        </div>
        <div class="text-box">
          <p>
            《亿慧工资条隐私政策》适用于您使用亿慧工资条网站gzt.gjyxms.com的产品或服务时使用。亿慧工资条网站的运营主体为：天津市亿慧网络科技有限公司，公司的注册地址和常用办公地址为：天津市西青区杨柳青镇新华道63号-2号。
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">二、我们如何收集和使用您的个人信息</div>
        <div class="text-box">
          <p>（一）向您提供我们的产品或服务</p>
          <p>1、主要功能及相关个人信息</p>
          <p>（1）成为我们的注册\登录用户</p>
          <p>
            您在使用亿慧工资条网站提供的服务时首先需要注册\登录成为亿慧工资条用户。注册成为亿慧工资条用户需要提供您本人的<span
              class="bold"
              >手机号、任职公司名称、设置登录密码</span
            >，我们将通过发送短信验证码的方式来验证您的身份是否有效。
          </p>
          <p>（2）工资条的发放和使用</p>
          <p>
            当您代表企业用户使用工资条功能时您需要上传excel形式的<span
              class="bold"
              >员工工资单</span
            >亿慧工资条系统会自动将您上传的工资单拆分成工资条发送给您的员工。您工资单上的员工注册亿慧小秘书app后即可查看自己的工资条。
          </p>
          <p>（3）客户服务及争议处理</p>
          <p>
            当您向亿慧工资条网站反馈信息或咨询信息时，我们可能需要您提供<span
              class="bold"
              >姓名、手机联系方式、电子邮箱</span
            >信息，以便我们及时向您提供反馈或咨询结果。如果您拒绝提供以上信息，相关功能可能无法使用。
          </p>
          <p>（二）征得授权同意的例外</p>
          <p>
            根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：
          </p>
          <p>1、与国家安全、国防安全直接相关的；</p>
          <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
          <p>
            4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>
          <p>5、所收集的个人信息是您自行向社会公众公开的；</p>
          <p>
            6、从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；
          </p>
          <p>7、根据您的要求签订和履行合同所必需的；</p>
          <p>8、法律法规规定的其他情形。</p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">三、我们如何使用Cookie和同类技术</div>
        <div class="text-box">
          <p>
            为了使您获得更轻松的访问体验，您访问亿慧工资条网站或使用亿慧工资条网站的服务时，我们可能会通过名为cookie的小型数据文件识别您的身份，这样做是为了帮助您省去重复输入注册信息的步骤，或者帮助判断您的账号安全状态。<span
              class="bold"
              >我们不会将cookie用于《亿慧工资条隐私政策》所述目的外的任何其他用途。如您的浏览器或浏览器的附加服务允许，您可以修改对cookie的接受程度或者拒绝亿慧工资条的cookie。但您这么做在某些情况下可能会影响您使用亿慧工资条的服务或安全访问亿慧工资条网站。</span
            >
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">
          四、我们如何共享、转让、公开披露您的个人信息
        </div>
        <div class="text-box">
          <p>
            （一）共享<br />
            我们不会与亿慧工资条以外的任何公司、组织和个人分享您的个人信息，但以下情形除外：
          </p>
          <p>
            1、与我们的关联公司共享：您的个人信息可能会与亿慧工资条的关联公司共享，但依然受本隐私政策中所声明目的的约束。关联公司如果想要改变个人信息的处理目的，将会再次征求您的授权同意。
          </p>
          <p>
            2、与授权合作伙伴共享：为了给您提供更好的用户体验和客户服务，我们可能与合作伙伴共享您的某些个人信息。共享的这些个人信息仅为实现本隐私中声明的目的。我们仅会共享您的必要的个人信息，我们的合作伙伴无权将您的个人信息用于其他目的。
          </p>
          <p>
            （二）转让<br />
            我们不会将您的个人信息转让给除亿慧工资条公司及其关联公司外的其他任何公司、组织和个人，但以下情形除外：
          </p>
          <p>
            1、事先获得您的明确同意或授权；
          </p>
          <p>
            2、根据法律法规或强制性的行政或司法的要求；
          </p>
          <p>
            3、在涉及合并、收购或破产清算时，如果涉及到您个人信息的转让，我们会要求新的持有您个人信息的公司、组织机构继续受本隐私协议的约束，否则我们将要求该公司、组织重新获得您的同意或授权。
          </p>
          <p>
            （三）公开披露<br />
            我们仅会在以下情形，公开披露您的个人信息：
          </p>
          <p>
            1、获得您的明确同意后；
          </p>
          <p>
            2、基于法律法规、法律程序、诉讼或政府主管部门的强制要求下。
          </p>
          <p>
            （四）无需征得您同意共享、转让、公开披露您的个人信息的例外情形
          </p>
          <p>
            1、与国家安全、国防安全直接相关的；
          </p>
          <p>
            2、与公共安全、公共卫生、重大公共利益直接相关的；
          </p>
          <p>
            3、与犯罪侦查、起诉、审判和判决执行等直接相关的；
          </p>
          <p>
            4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
          </p>
          <p>
            5、您自行向社会公众公开的个人信息；
          </p>
          <p>
            6、从合法公开披露的信息中收集的个人信息，如：合法的新闻报道、政府信息公开等渠道；
          </p>
          <p>7、法律法规规定的其他情形。</p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">五、我们如何保存和保护您的个人信息</div>
        <div class="text-box">
          <p>（一）信息保存</p>
          <p>
            您在使用亿慧工资条的产品或服务期间，我们将持续保存您的个人信息。这些信息全部存储在中华人民共和国境内，如果需要跨境传输我们会以弹窗或其他形式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的能力保护您的个人信息的安全。
          </p>
          <p>（二）信息保护</p>
          <p>
            1、我们将努力采取各种合理的物理、电子、管理方面的措施来保障您的个人信息的安全，包括通过SSL协议加密保护数据的传输；信息加密存储；严格限制数据中心的访问；我们会通过校验账号密码或者手机号验证码的方式进行用户身份合法性的鉴别，尽力确保只有授权人员才能访问用户的个人信息。
          </p>
          <p>
            2、我们对可能接触到您个人信息的工作人员采取了严格管理。我们会同工作人员签署保密协议，根据工作人员岗位的不同分配不同的权限，监控工作人员的操作情况等。
          </p>
          <p>
            3、互联网并非百分百安全的环境，我们会尽力保护您所发放给亿慧工资条的个人信息安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以系统推送、短信、邮件、电话等形式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
          </p>
          <p>
            4、在使用亿慧工资条的过程中，<span class="bold"
              >请妥善保护您的个人信息，如果发现您的个人信息尤其是账号和密码有泄露的风险或已经泄露，请及时联系我们，以便我们采取相应的措施避免或降低您的损失。如果因个人原因泄露账号和密码造成的损失，您将自行承担。</span>
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">六、您管理个人信息的权力</div>
        <div class="text-box">
          <p>
            在使用亿慧工资条的产品\服务期间在法律、法规规定的范围内，您有权访问和管理您的个人信息。相应的操作如下：
          </p>
          <p>（一）个人信息的访问和修改</p>
          <p>
            您可以通过点击亿慧工资条网站的账号中心模块查看您的公司名称、手机号，您也可以对公司名称、手机号、密码进行修改。
          </p>
          <p>（二）个人信息的删除</p>
          <p>
            如果存在以下情形，您可以要求我们删除您的个人信息，我们的联系方式具体详见第九点。
          </p>
          <p>1、如果我们处理您个人信息的方式违反了法律法规；</p>
          <p>2、如果我们没有征得您的同意，收集和使用了您的个人信息；</p>
          <p>3、如果我们处理个人信息的方式违反了和您的约定；</p>
          <p>4、我们终止了对您的服务。</p>
          <p>（三）响应您的上述请求</p>
          <p>
            为保障安全您可能需要提供书面请求或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
          </p>
          <p>（四）无法响应请求的情形</p>
          <p>1、与国家安全、国防安全直接相关的；</p>
          <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
          <p>3、与犯罪侦查、起诉、审判和执行决定等直接相关的；</p>
          <p>4、有充分证据表明您存在主观恶意或滥用权力的；</p>
          <p>5、相应您的请求将导致其他个人、组织的合法权益收到严重损害的；</p>
          <p>6、涉及商业秘密的。</p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">七、我们如何处理未成年人的个人信息</div>
        <div class="text-box">
          <p>
            亿慧工资条网站主要为企业提供向员工发送工资条服务，基于我们产品或/与服务的性质，<span
              class="bold"
              >我们不向16周岁以下的未成年人提供服务。如果您是年满16周岁不满18周岁的未成年人，在使用我们的产品或/与服务前，请您在您的监护人的陪同下阅读本隐私政策，并确保在征得您的监护人的同意下使用我们的服务，或向我们提供您的个人信息。</span
            >
          </p>
          <p>
            如果您的监护人不同意您按本《亿慧工资条隐私政策》使用我们的服务或向我们提供您的信息，请立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
          </p>
          <p>
            如果监护人发现我们在未获得监护人同意的情况下收集了未成年人的个人信息，请根据《亿慧工资条隐私政策》中公布的联系方式及时联系我们，我们会尽快删除相关的信息。
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">八、本《亿慧工资条隐私政策》的更新和通知</div>
        <div class="text-box">
          <p>
            在发生重大变化时，我们可能会适时更新本《亿慧工资条隐私政策》。如果本隐私政策发生更新，我们会以系统推送、发送邮件/短信消息或以页面公告的方式通知您。若您在本隐私政策更新生效后继续使用亿慧工资条提供的服务，即表示您同意受更新后《亿慧工资条隐私政策》的约束。
          </p>
          <p>
            若您在本隐私政策更新生效后继续使用亿慧小秘书提供的服务，即表示您同意受更新后《亿慧小秘书隐私政策》的约束。
          </p>
          <p>本《亿慧工资条隐私政策》指的重大变化包括但不限于以下情况：</p>
          <p>
            1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
          </p>
          <p>2、个人信息共享、转让或公开披露的主要对象发生变化；</p>
          <p>3、您参与个人信息处理方面的权力及其行驶方式发生重大变化；</p>
          <p>
            4、我们的基本情况发生变化，如业务调整、破产并购等引起的所有者的变更等。
          </p>
          <p>5、我们处理个人信息的联络方式、投诉渠道发生变化时；</p>
          <p>6、其他可能对您的个人信息权益产生重大影响的变化。</p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">九、如何联系我们</div>
        <div class="text-box">
          <p>
            如您对本《亿慧工资条隐私政策》有任何疑问或对我们处理您个人信息的方式有任何疑问、意见或建议，<span
              class="bold"
              >您可以发送邮件至yhgzt@gjyxms.com</span
            >与我们联系，我们将尽快给与您答复。一般情况下我们将在十五天内（遇国家法定节假日顺延）回复。
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">十、争议解决</div>
        <div class="text-box">
          <p>
            因本《亿慧工资条隐私政策》或我们处理您个人信息时引起的任何争议，<span
              class="bold"
              >任何一方均可向有管辖权的法院提起诉讼。</span
            >。
          </p>
        </div>
      </div>
      <div class="box">
        <div class="sub-title">附录：关键词说明</div>
        <div class="text-box">
          <p>
            本《亿慧小秘书隐私政策》中用到的关键词说明如下：
          </p>
          <p>1、“我们“或”亿慧工资条公司“指天津市亿慧网络科技有限公司。</p>
          <p>
            2、“关联公司“指亿慧工资条平台运营主体直接或间接控制的法人实体及其分支机构，与亿慧工资条平台运营主体直接或间接共同受控于同一实际控制人的法人实体及其分支机构；控制、受控指：通过协议或股权控制或受控。例如：天津市军慧劳务服务有限公司、天津科慧人力资源有限公司。
          </p>
          <p>
            3、“您“或”用户“指使用天津市亿慧网络科技有限公司运营的平台产品或服务的注册用户。
          </p>
          <p>
            4、“亿慧工资条平台的产品与/或服务“、”亿慧工资条平台“指亿慧工资条网站。
          </p>
          <p class="bold">
            5、“个人敏感信息“指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康收到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息、个人身份信息、网络身份标识信息等。
          </p>
          <p>
            6.“个人信息”，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      agreeUrl: '/agree',
      privacyUrl: '/privacy',
    }
  }
}
</script>

<style scoped lang="less">
.policy-page {
  padding: 10px 16px;
  font-size: 14px;
  line-height: 20px;
  width: 900px;
    margin: 0 auto;
  a {
    color: #4e90ff;
  }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    padding: 10px;
  }
  .pre-text {
    span {
      display: block;
      text-align: left;
    }
    .intro {
      font-weight: 700;
    }
  }
  .content {
    .box {
      margin-top: 10px;
      .sub-title {
        padding-bottom: 5px;
        font-weight: 700;
        text-align: left;
      }
    }
  }
  .bold {
    font-weight: 700;
  }
}
</style>
